import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=4b54d178&scoped=true&"
import script from "./DropDown.vue?vue&type=script&lang=js&"
export * from "./DropDown.vue?vue&type=script&lang=js&"
import style0 from "./DropDown.vue?vue&type=style&index=0&id=4b54d178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54d178",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VList,VListItem,VListItemTitle,VMenu})
